import _toConsumableArray from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.join.js";
import Head from "@/components/Head/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import Pagination from "@/components/Pagination/index.vue";
import { defineComponent, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import 'element-plus/es/components/message/style/index'

export default defineComponent({
  name: "MyBookCase",
  components: {
    Head: Head,
    Pagination: Pagination
  },
  setup: function setup() {
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var baseurl = process.env.VUE_APP_BASE_URL;
    var editState = ref(false);
    var delNum = ref(0);
    var totalNum = ref(0);
    var pageIndex = ref(1);
    var booklist = ref([{
      bookName: "",
      coverPic: "",
      author: ""
    }]);
    var choseBook = reactive([]); // 列表请求参数

    var listParams = {
      pageIndex: 1,
      pageSize: 12
    }; // 获取书籍

    function getAllBookbyPage() {
      return _getAllBookbyPage.apply(this, arguments);
    }

    function _getAllBookbyPage() {
      _getAllBookbyPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data, total;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getBookMyBookcase"](listParams);

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                total = _yield$globalProperti.total;
                booklist.value = _toConsumableArray(data);
                totalNum.value = total;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getAllBookbyPage.apply(this, arguments);
    }

    getAllBookbyPage();

    function toDetail(res) {
      if (editState.value == true) return;
      router.push({
        name: "myBookCaseDetail",
        query: {
          id: res.bookId
        }
      });
    }

    function changeEdit(res) {
      editState.value = res;
      delNum.value = 0;
      choseBook = [];
    }

    var circleHtml = ref();

    function circleEdit(res, index) {
      if (editState.value == false) return;
      circleHtml.value = document.getElementsByClassName("circle");
      var a = circleHtml.value[index];

      if (a.className == "circle") {
        delNum.value++;
        choseBook.push(res.bookId);
      } else {
        delNum.value--;
        choseBook.forEach(function (item, index) {
          if (item == res.bookId) {
            choseBook.splice(index, 1);
          }
        });
      }

      a.className = a.className == "circle" ? "circleChose circle " : "circle";
    }

    function deleteBook() {
      return _deleteBook.apply(this, arguments);
    } //查看排行


    function _deleteBook() {
      _deleteBook = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$globalProperti2, code;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getMyBookcaseDel"](choseBook.join(','));

              case 2:
                _yield$globalProperti2 = _context2.sent;
                code = _yield$globalProperti2.code;

                if (code == 0) {
                  ElMessage({
                    message: "删除成功",
                    type: "success"
                  });
                  delNum.value = 0;
                  choseBook = [];
                  getAllBookbyPage();
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _deleteBook.apply(this, arguments);
    }

    var Rank = function Rank() {
      router.push({
        name: "integralRank"
      });
    };

    function changPage(val) {
      listParams.pageIndex = val;
      getAllBookbyPage();
    }

    return {
      baseurl: baseurl,
      booklist: booklist,
      editState: editState,
      changeEdit: changeEdit,
      circleEdit: circleEdit,
      circleHtml: circleHtml,
      getAllBookbyPage: getAllBookbyPage,
      delNum: delNum,
      totalNum: totalNum,
      pageIndex: pageIndex,
      changPage: changPage,
      toDetail: toDetail,
      Rank: Rank,
      deleteBook: deleteBook
    };
  }
});